import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-sa-route-breadcrumbs',
    template: `
        <ol class="breadcrumb">
            <li *ngFor="let item of items">{{item}}</li>
        </ol>
    `,
    styles: []
})
export class RouteBreadcrumbsComponent implements OnInit, OnDestroy {

    public items: Array<string> = [];
    private sub;

    constructor(
        private router: Router
    ) {
    }

    ngOnInit() {
        this.extract(this.router.routerState.root);
        this.sub = this.router.events
            .subscribe(() => {
                this.items = [];
                this.extract(this.router.routerState.root)
            });

    }

    ngOnDestroy(): void {
        this.sub.unsubscribe()
    }


    extract(route) {
        const pageTitle = route.data.value['pageTitle'];
        if (pageTitle && this.items.indexOf(pageTitle) === -1) {
            this.items.push(route.data.value['pageTitle'])
        }
        if (route.children) {
            route.children.forEach(it => {
                this.extract(it)
            })
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/layout/ribbon/route-breadcrumbs.component.ts